// extracted by mini-css-extract-plugin
export default {"description":"style_description__J+5cE","fade-in":"style_fade-in__fn9OV","top":"style_top__F3DvA","image":"style_image__lhz2o"};